import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, switchMap, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import { RmService } from '@bidi/common-services';
import { RatingsActionTypes, GetRatingsSuccess, GetRatingsFailure, SetRatings, SetRatingsSuccess } from './actions';

@Injectable()
export class RatingsEffects {
  constructor (
    private actions$: Actions,
    private rm: RmService
  ) {
  }

  @Effect()
  getRatings$: Observable<any> = this.actions$.pipe(
    ofType(RatingsActionTypes.GET_RATINGS),
    mergeMap<any, any>(({ payload }) =>
      this.rm.getRatings(payload).pipe(
        switchMap(res => of(
          new GetRatingsSuccess({id: payload, ratings: res})
        )),
        catchError(err => of(
          new GetRatingsSuccess({id: payload, ratings: {}})
          // new GetRatingsFailure(err)
        ))
      )
    )
  );

  @Effect()
  setRatings$: Observable<any> = this.actions$.pipe(
    ofType(RatingsActionTypes.SET_RATINGS),
    switchMap<any, any>(({ payload }) =>
      this.rm.setRating(payload).pipe(
        switchMap(() => of(
          new SetRatingsSuccess({id: payload.resource, data: payload})
        )),
        catchError(err => of(
          new GetRatingsFailure(err)
        ))
      )
    )
  );
}
